import { Component, EventEmitter, Output } from '@angular/core';
import { VirtualService, game, companygame, EventListingService, ConfigService, SharedService } from 'baseline-lib';
import { Global } from '../../../global/global';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingController, NavController } from 'ionic-angular';

/**
 * Generated class for the VirtualHomeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'virtual-home',
  templateUrl: 'virtual-home.html'
})
export class VirtualHomeComponent {

  @Output() onclickevent: EventEmitter<any> = new EventEmitter<any>();
  _gameList: game[] = [];
 _selectedGame : game ;
 public _imageUrl : string ;

  constructor(public _virtualService : VirtualService,public globalData : Global,
    public _eventListingService : EventListingService,private sanitizer : DomSanitizer,
    public _configService : ConfigService,public loadingCtrl : LoadingController,
    public _sharedService : SharedService, public navCtrl : NavController) {

    console.log('Hello VirtualHomeComponent Component');
    this._gameList = [];
    this._imageUrl = this._configService.getImageUrl();
    console.log(this._imageUrl)
  }

  ngOnInit(): void {
    //this.globalData.isLoaderShownHomepage = true;
    this._sharedService.showLoader();
    
    this._virtualService.getGameListById(this.globalData.selectedGameId)
    .subscribe(
      data => {

        this.resetSelectedGame();
        if (data.gli) {
          data.gli.forEach(_game => {
            var _g = new game();
            _g.gametypeid = this.globalData.selectedGameId;
            _g.constructGame(_game);
            _game.companygames =[];
            if (_game.cgli) {
              _game.cgli.forEach(cg => {
                var _cg = new companygame();
                _cg.parse(cg);
                if(_cg.spec && _cg.spec.vwurl)
                    cg.spec.vwurl = this.sanitizer.bypassSecurityTrustResourceUrl(cg.spec.vwurl );
                
                _g.companygames.push(_cg);
              });
            };
            this._gameList.push(_g);
          });
        }

      //  this.filterGames();

        //temp load first game.
        // navigate to first game in the list
        console.log(this._gameList);
        if (this._gameList) {
          if (this._gameList.length > 0) {
            if (this._gameList[0].companygames) {
              if (this._gameList[0].companygames.length > 0) {
                this._selectedGame = this._gameList[0];
                this._selectedGame.isSelected = true;
                this._eventListingService.EventListObj.gameObj = this._selectedGame ;
                this.onclickevent.emit(this._selectedGame);
              }
            }
          }
        }
        this._eventListingService.gameList = this._gameList;
      },
      error => {
        this._sharedService.hideLoader();
      });

      setTimeout(() => {
        this._sharedService.hideLoader();
      }, 500);
  }

  resetSelectedGame() {
    this._selectedGame = undefined;
  }

  gameclick(_game) {

    this._selectedGame = _game;
    this._sharedService.showLoader();
    //this._sharedService.toggle1 = false;
    this._sharedService.hideLoader();

    if(!this._eventListingService.gameList)
      this._eventListingService.gameList = this._gameList;
      this._eventListingService.gameList.forEach(_game => _game.isSelected = false );
    this._selectedGame.isSelected = true;
    this._eventListingService.EventListObj.gameObj = this._selectedGame ;
    this._eventListingService.EventListObj.resultEvent = undefined;
    //this.mobileSharedService.gamelistHide = true;
    this.onclickevent.emit(this._selectedGame);
    //this.navCtrl.push(VirtualGamePage, {gameObj : this._selectedGame});
  }

}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/virtual-home/virtual-home.ts